import React from "react";
import { maxPlatform } from "../services/maxPlatform";

/** http(s) or www.… — trailing punctuation stays outside the link. */
const URL_RE = /(https?:\/\/[^\s<>"'`]+|www\.[^\s<>"'`]+)/gi;
const TRAIL_PUNCT_RE = /[),.;:!?]+$/;

function splitUrlMatch(raw: string): { href: string; display: string; trail: string } {
  let display = raw;
  let trail = "";
  const m = display.match(TRAIL_PUNCT_RE);
  if (m) {
    trail = m[0];
    display = display.slice(0, -trail.length);
  }
  const href = /^https?:\/\//i.test(display) ? display : `https://${display}`;
  return { href, display, trail };
}

function openUrl(href: string, e: React.MouseEvent) {
  e.preventDefault();
  e.stopPropagation();
  maxPlatform.openExternalLink(href);
}

/**
 * Renders plain text with clickable http(s)/www links (MAX-safe via openExternalLink).
 */
export function linkifyText(
  text: string,
  linkClassName: string,
): React.ReactNode {
  if (!text) return text;
  const nodes: React.ReactNode[] = [];
  let last = 0;
  let match: RegExpExecArray | null;
  const re = new RegExp(URL_RE.source, URL_RE.flags);
  while ((match = re.exec(text)) !== null) {
    if (match.index > last) {
      nodes.push(text.slice(last, match.index));
    }
    const { href, display, trail } = splitUrlMatch(match[0]);
    nodes.push(
      <a
        key={`u-${match.index}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => openUrl(href, e)}
        className={linkClassName}
      >
        {display}
      </a>,
    );
    if (trail) nodes.push(trail);
    last = match.index + match[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes.length === 1 ? nodes[0] : nodes;
}
